import { useNavigate, useLocation } from "react-router-dom";
import Login from "../login/Login";

export default function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLoginSuccess = (userData) => {
    localStorage.setItem("user", JSON.stringify(userData));
    const redirectTo = location.state?.from?.pathname || "/";
    navigate(redirectTo);
  };

  return <Login onLoginSuccess={handleLoginSuccess} />;
}
